/**
 * Date utils start
 */

window.getEasterDate = function (year) {
  const f = Math.floor;
  const a = year % 19;
  const b = f(year / 100);
  const c = year % 100;
  const d = f(b / 4);
  const e = b % 4;
  const g = f((8 * b + 13) / 25);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = f(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = f((a + 11 * h + 22 * l) / 451);
  const month = f((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

/**
 * Get list of public holidays in Poland (fixed + movable).
 * @param {number} year - Full year.
 * @returns {Date[]} List of holiday dates.
 */
window.getHolidays = function (year) {
  const easter = getEasterDate(year);
  const holidays = [
    new Date(year, 0, 1),   // Neujahr (New Year's Day)
    new Date(year, 4, 1),   // Tag der Arbeit (Labour Day)
    new Date(year, 9, 3),   // Tag der Deutschen Einheit (German Unity Day)
    new Date(year, 11, 25), // 1. Weihnachtstag (Christmas Day)
    new Date(year, 11, 26), // Second Day of Christmas
  ];

  // Karfreitag (Good Friday) - 2 days before Easter
  const goodFriday = new Date(easter);
  goodFriday.setDate(easter.getDate() - 2);

  // Ostermontag (Easter Monday) - 1 day after Easter
  const easterMonday = new Date(easter);
  easterMonday.setDate(easter.getDate() + 1);

  // Christi Himmelfahrt (Ascension Day) - 39 days after Easter
  const ascensionDay = new Date(easter);
  ascensionDay.setDate(easter.getDate() + 39);

  // Pfingstmontag (Whit Monday) - 50 days after Easter
  const whitMonday = new Date(easter);
  whitMonday.setDate(easter.getDate() + 50);

  holidays.push(goodFriday, easterMonday, ascensionDay, whitMonday);

  return holidays.map((d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()));
}

/**
 * Check if a given date is a weekend or holiday.
 * @param {Date} date - Date to check.
 * @param {Date[]} holidays - Array of holiday dates.
 * @returns {boolean} True if non-working day.
 */
window.isNonWorkingDay = function (date, holidays) {
  const day = date.getDay();
  if (day === 0 || day === 6) return true; // Sunday or Saturday

  return holidays.some((h) => h.getTime() === date.getTime());
}

/**
 * Add business days to a given date.
 * @param {Date} startDate - Starting date.
 * @param {number} businessDays - Number of business days to add.
 * @returns {Date} Resulting date.
 */
window.addBusinessDays = function (startDate, businessDays) {
  const date = new Date(startDate);
  let addedDays = 0;

  while (addedDays < businessDays) {
    date.setDate(date.getDate() + 1);
    const holidays = getHolidays(date.getFullYear());
    if (!isNonWorkingDay(date, holidays)) {
      addedDays += 1;
    }
  }
  return date;
}

/**
 * Count business days between two dates (inclusive).
 * - weekends and PL holidays are excluded
 * - order-agnostic (from can be after to)
 * - does not mutate inputs
 */
window.getBusinessDaysCountBetween = function (from, to) {
  if (!(from instanceof Date) || isNaN(from) || !(to instanceof Date) || isNaN(to)) {
    throw new TypeError("from and to must be valid Date objects");
  }

  // normalize to local midnight to compare date-only
  const start = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const end = new Date(to.getFullYear(), to.getMonth(), to.getDate());

  // ensure start <= end
  const forward = start <= end;
  const first = forward ? start : end;
  const last = forward ? end : start;

  // cache holidays per year to avoid recomputing on every day
  const holidaysByYear = {};
  const getYearHolidays = (y) => {
    if (!holidaysByYear[y]) {
      holidaysByYear[y] = window.getHolidays(y);
    }
    return holidaysByYear[y];
  };

  let count = 0;
  const cursor = new Date(first);

  while (cursor <= last) {
    const holidays = getYearHolidays(cursor.getFullYear());
    if (!window.isNonWorkingDay(cursor, holidays)) {
      count += 1;
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return count;
};

/**
 * Date utils end
 */
